import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
      path: '',
      data: {
          title: 'User'
      },
      children: [
          {
              path: '',
              redirectTo: 'config', 
              pathMatch: 'full'
          },
          {
            path: 'config',
            loadChildren: () => import('./configurations/configurations.module').then(m => m.ConfigurationsModule)
          }
      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientRoutingModule { }
